export const environment = {
  production: true,
  buildId: '3340431089921651',
  configFile: 'config.json',
};
